import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    mainCardReportWrapper: {
        position: "absolute",
        top: -40,
        left: 20,
        width: "100%",
        boxSizing: "border-box",
        zIndex: 1500,
    },
    innerWrapper: {
        position: "relative",
        width: "100%",
        height: "100%",
    },
    closeButton: {
        padding: "0 !important",
    },
    closeButtonIcon: {
        fontSize: "18px !important",
    },
    graphWrapper: {
        width: "100%",
        height: "100%",
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
}));
